import React, { useState,useEffect } from 'react'
import StockTakingForm from './components/StockTakingForm'
import { MwButton } from '../../components/ui'
import { useCurrent, useFetch, usePost } from '../../hooks';
import { useTranslation } from 'react-i18next';
import CardHeadeWithActions from './../../components/ui/CardHeadeWithActions';

const AddStockTaking = ({setAdded, setShowAddForm}) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
        const [t,i18n ] = useTranslation('global')
    
    const formattedToday = dd + '/' + mm + '/' + yyyy;

    const [stocktakingForm,setStocktakingForm] = useState({
        warehouse:{},
        code:'',
        stocktaking_at: formattedToday
    });
    const [code,setCode] = useState('');
    const {currentTenantId,currentCompanyId,currentBranchId} = useCurrent();
    const {data:warehosesResult,loading:loadingWarehouse} = useFetch(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/master/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`)
    const {data:postDataResult,loading:postLoading,postData} = usePost();
    
    useEffect(() => {
        if(warehosesResult){
            const newCode = `${ (parseInt(warehosesResult?.data)+1).toString().padStart(5,'0')}-${stocktakingForm?.warehouse?.code || 'Stk'}`
            setCode(newCode)
        }
        console.log('stocktakingForm',stocktakingForm);
    },[warehosesResult,stocktakingForm]);

    useEffect(()=>{
        console.log('code',code)
    },[code])

    useEffect(()=>{
        if(postDataResult){
            setAdded(true);
            setShowAddForm(false); // Return to list view after successful submission
        }
    },[postDataResult]);

    const submitHandler = () => {
        setAdded(false);
        const _data = {
            warehouse_id :stocktakingForm?.warehouse?.id,
            code: stocktakingForm?.code,
            stocktaking_at: stocktakingForm?.stocktaking_at,
            tenant_id:currentTenantId,
            company_id:currentCompanyId,
            branch_id:currentBranchId
        }

        postData(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/master`,_data);
    }

    return (
        <>
        <div className='p-5 bg-slate-100 rounded-lg shadow-sm my-3'>
            <CardHeadeWithActions 
                title={<div className="flex items-center gap-2">
                    <span className='text-xs'>{t('stocktaking.add_new_inventory')}</span>
                </div>}
            >
            </CardHeadeWithActions>
            <StockTakingForm code={code} setCode={setCode} stocktakingForm={stocktakingForm} setStocktakingForm={setStocktakingForm} />
            <div className='flex flex-row-reverse'>
                <MwButton type='saveBtn' onClick={submitHandler}>{t('stocktaking.approved')}</MwButton>
            </div>
        </div>
    </>
    )
}

export default AddStockTaking